import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const usa = (m, k) => `${m?.oggetto || ""} ${m?.testo || ""}`.includes(`{${k}}`);
const riempi = (txt, vals) => (txt || "").replace(/\{(\w+)\}/g, (all, k) => (vals[k] ? vals[k] : all));

// Selettore modello email: compila oggetto/messaggio, chiede solo i campi usati dal modello.
export function ModelloPicker({ ragioneSociale, onApply }) {
  const [data, setData] = useState({ modelli: [], impostazioni: {} });
  const [prodotti, setProdotti] = useState([]);
  const [sel, setSel] = useState("");
  const [v, setV] = useState({ prodotto: "", numero_polizza: "", premio_lordo: "" });

  useEffect(() => {
    api.get("/modelli-email").then(({ data: d }) => setData(d)).catch(() => {});
    api.get("/catalogo/prodotti").then(({ data: d }) => setProdotti(d)).catch(() => {});
  }, []);

  const modello = data.modelli.find((m) => m.id === sel);
  const attivi = data.modelli.filter((m) => m.attivo);
  const prodOpz = useMemo(() => (modello?.prodotti?.length ? prodotti.filter((p) => modello.prodotti.includes(p.code)) : prodotti), [modello, prodotti]);
  const nomeProd = (m) => (m.prodotti?.length ? prodotti.filter((p) => m.prodotti.includes(p.code)).map((p) => p.nome).join(", ") : "tutti i prodotti");

  useEffect(() => {
    if (!modello) return;
    const vals = { ...data.impostazioni, ...v, ragione_sociale: ragioneSociale };
    onApply({ oggetto: riempi(modello.oggetto, vals), messaggio: riempi(modello.testo, vals) });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sel, v]);

  const choose = (id) => {
    const m = data.modelli.find((x) => x.id === id);
    const unico = m?.prodotti?.length === 1 ? prodotti.find((p) => p.code === m.prodotti[0])?.nome : "";
    setV((x) => ({ ...x, prodotto: unico || x.prodotto }));
    setSel(id);
  };

  if (!attivi.length) return null;
  return (
    <div className="rounded-lg border border-indigo-200 bg-indigo-50/40 p-3 space-y-2" data-testid="abi-invio-modello-box">
      <Label>Modello di messaggio</Label>
      <select value={sel} onChange={(e) => choose(e.target.value)} className="w-full h-9 text-sm border border-slate-200 rounded-md px-2 bg-white" data-testid="abi-invio-modello">
        <option value="">— scrivi un messaggio libero —</option>
        {attivi.map((m) => <option key={m.id} value={m.id}>{m.titolo} ({nomeProd(m)})</option>)}
      </select>
      {modello && (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
          {usa(modello, "prodotto") && (
            <div className="space-y-1"><Label className="text-xs">Prodotto</Label>
              <select value={v.prodotto} onChange={(e) => setV({ ...v, prodotto: e.target.value })} className="w-full h-9 text-sm border border-slate-200 rounded-md px-2 bg-white" data-testid="abi-invio-modello-prodotto">
                <option value="">— scegli —</option>
                {prodOpz.map((p) => <option key={p.code} value={p.nome}>{p.nome}</option>)}
              </select>
            </div>
          )}
          {usa(modello, "numero_polizza") && <div className="space-y-1"><Label className="text-xs">Numero polizza</Label><Input value={v.numero_polizza} onChange={(e) => setV({ ...v, numero_polizza: e.target.value })} data-testid="abi-invio-modello-polizza" /></div>}
          {usa(modello, "premio_lordo") && <div className="space-y-1"><Label className="text-xs">Premio lordo (€)</Label><Input value={v.premio_lordo} onChange={(e) => setV({ ...v, premio_lordo: e.target.value })} placeholder="es. 588,00" data-testid="abi-invio-modello-premio" /></div>}
        </div>
      )}
      {modello && /\{\w+\}/.test(`${riempi(modello.oggetto, { ...data.impostazioni, ...v, ragione_sociale: ragioneSociale })}${riempi(modello.testo, { ...data.impostazioni, ...v, ragione_sociale: ragioneSociale })}`) && (
        <p className="text-[11px] text-amber-700" data-testid="abi-invio-modello-mancanti">Completa i campi sopra: nel testo restano segnaposto da compilare.</p>
      )}
    </div>
  );
}
